import React from 'react';
import DOMPurify from 'dompurify';

// Images inside posts load lazily and never stretch past the column.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'IMG') {
        node.setAttribute('loading', 'lazy');
        node.setAttribute('decoding', 'async');
    }
});

function PostContent({ html, className = '' }) {
    const safeHtml = DOMPurify.sanitize(html || '', {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed'],
        FORBID_ATTR: ['onerror', 'onload'],
    });

    return (
        <div
            className={`post-content ${className}`.trim()}
            dangerouslySetInnerHTML={{ __html: safeHtml }}
        />
    );
}

export default PostContent;
